export const Access_Token_key = 'a_t_key'

export const Pass_Knowledge_Url = '/wulai/proxy/graphql/paas-knowledge'

export const TagNameFlag = '@##@'

// 日程提醒的提前提醒时间选项
export const advanceList = [
    {
        value: 0,
        text: '事件开始时',
    },
    {
        value: 5,
        text: '提前5分钟',
    },
    {
        value: 15,
        text: '提前15分钟',
    },
    {
        value: 30,
        text: '提前30分钟',
    },
    {
        value: 60,
        text: '提前1小时',
    },
    {
        value: 60 * 24,
        text: '提前1天',
    },
]

export const repeatList = [
    {
        value: 'date',
        text: '仅一次',
    },
    {
        value: 'daily',
        text: '每天',
    },
    {
        value: 'weekly',
        text: '每周(可多选)',
        list: ['一', '二', '三', '四', '五', '六', '日'],
    },
    {
        value: 'monthly',
        text: '每月',
    },
    {
        value: 'yearly',
        text: '每年',
    },
]
